// removed by extract-text-webpack-plugin
module.exports = {"project":"_1bmTs60v3E8q0zgDOiDm_M","descriptionSection":"_3jQQ_mCfIh6HBJn56EBaEo","name":"HDsd5A1xzjT7mc_tQO3xh","summary":"_12wEDwu2pMbjdus3Uk1Q7O","status":"_3cmnSn1vg3QlYrOnzPJgGY","projectSliderWrapper":"z3TBoPR9g9a2csEfnywUJ","photoBlockWrapper":"_3irk6stP3mljGmW2nQIASM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ForeignProject/ForeignProject.scss
// module id = 1595
// module chunks = 0